export enum PermissionsEnums {
    MainUser = '1',
    subAccount = '2',
    CanUseApi = '4',
    CanChangeData = '3',
    CanSendMessageDirect = '5',
    CanCreateSubAccount = '6',
    canShowDev = '7',
    CanUseWhatsapp = '8',
}